import { Route, Routes } from "react-router-dom";
import { Layout } from "layouts/Layout";
import { Home } from "pages/Home";
import ModernWorkplace from "pages/ModernWorkplace";
import DataLifeCycle from "./pages/DataLifeCycle";
import Automation from "./pages/Automation";
import Managed from "./pages/Managed";
import OurCompany from "./pages/OurCompany";
import ScrollToHashElement from "@cascadia-code/scroll-to-hash-element";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/common/ScrollToTop";
import InitialLoader from "./components/common/InitialLoader";

function App() {
	return (
		<div className="App">
			<InitialLoader />
			<ScrollToTop />
			<ScrollToHashElement alignToTop={true} behavior="smooth"/>
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<Home />} />
					<Route path="/modern-workspace">
						<Route index element={<ModernWorkplace />} />
					</Route>
					<Route path="/data-lifecycle">
						<Route index element={<DataLifeCycle/>}/>
					</Route>
					<Route path="/automation">
						<Route index element={<Automation/>}/>
					</Route>
					<Route path="/managed-services">
						<Route index element={<Managed/>}/>
					</Route>
					<Route path="/about-us">
						<Route index element={<OurCompany/>}/>
					</Route>
					<Route path="/contact-us">
						<Route index element={<Contact/>}/>
					</Route>
				</Route>
			</Routes>
		</div>
	);
}

export default App;
